import { PostHogProvider } from "@posthog/react";
import { useEffect, type ReactNode } from "react";
import { initMetaPixel } from "../analytics/metaPixel";
import { capture, initPostHog, isPostHogConfigured, posthog } from "../analytics/posthog";
import { recordSocialPushClick } from "../analytics/social";

type PostHogAnalyticsProviderProps = {
  children: ReactNode;
};

const PostHogAnalyticsProvider = ({
  children,
}: PostHogAnalyticsProviderProps) => {
  useEffect(() => {
    initMetaPixel();
  }, []);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return undefined;

    const onMessage = (event: MessageEvent) => {
      if (event.data?.type !== "PUSH_CLICKED") return;
      capture("push_clicked", {
        notification_type: event.data.notificationType ?? null,
        notification_id: event.data.notificationId ?? null,
      });
      recordSocialPushClick(event.data.notificationType ?? null);
    };

    navigator.serviceWorker.addEventListener("message", onMessage);
    return () => {
      navigator.serviceWorker.removeEventListener("message", onMessage);
    };
  }, []);

  if (!isPostHogConfigured()) {
    return children;
  }

  initPostHog();

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};

export default PostHogAnalyticsProvider;
